import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Datasection from '../../components/dataSection/dataSection';
import Datamodal from '../../components/dataModal/dataModal';

class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    }

  }

  render() {
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page" style={{ minHeight: '100vh'}}>
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Users
                        <small>
												  All the system users
											</small>
                      </h3>
                    </div>
                  </div>
                  <div className="m-portlet__head-tools">
                    <ul className="m-portlet__nav">
                      <li className="m-portlet__nav-item">
                        {/* <button className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air" data-toggle="modal" data-target="#existing_user">
                          <span>
                            <i className="la la-plus"></i>
                            <span>Existing User</span>
                          </span>
                        </button> */}
                        <button className="btn btn-accent m-btn m-btn--custom m-btn--pill m-btn--icon m-btn--air" data-toggle="modal" data-target="#new_user">
                          <span>
                            <i className="la la-plus"></i>
                            <span>New User</span>
                          </span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="m-portlet__body m-portlet__body_grey">
                  <Datasection />
                </div>
              </div>
              <Datamodal />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});


export default withRouter(connect(mapStateToProps)(Users));
